import { css } from "@emotion/react";
import { useContext, useMemo } from "react";
import { PublicationButton } from "../bits/buttons/PublicationButton";
import { LoadingSpinner } from "../bits/loading";
import { UserPublicationsContext } from "../contexts/WithPublications/UserPublicationsContext";
import Shelf from "@assets/shelf.svg";
import { useUser } from "../hooks/useUser";

export const Bookshelf = ({
  className,
  homeView,
}: {
  className?: string;
  homeView?: boolean;
}) => {
  const { publications, isLoading } = useContext(UserPublicationsContext);
  const { user } = useUser();

  const orderedPublications = useMemo(
    () =>
      publications
        ? [...publications].sort((a, b) => {
            if (!user) {
              return 0;
            }
            const aIndex = user.recentPublications.findIndex(
              (pub) => pub.publication === a.id,
            );
            const bIndex = user.recentPublications.findIndex(
              (pub) => pub.publication === b.id,
            );

            if (aIndex === -1 && bIndex === -1) {
              return 0;
            }
            if (aIndex === -1) {
              return 1;
            }
            if (bIndex === -1) {
              return -1;
            }
            return aIndex - bIndex;
          })
        : publications,
    [publications, user],
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!orderedPublications?.length) {
    return <div>No publications found</div>;
  }

  return (
    <>
      <div
        className={className}
        css={css`
          position: relative;
          display: flex;
          overflow: hidden;
          justify-content: center;
          flex-wrap: wrap;
          row-gap: 80px;
          column-gap: 40px;
          padding: 22px 40px 80px 40px;
        `}
      >
        {orderedPublications.map((pub) => {
          const recentPublication = user?.recentPublications.find(
            (recent) => recent.publication === pub.id,
          );
          return (
            <PublicationButton
              homeView={homeView}
              key={pub.filename}
              publication={pub}
              recentPublication={recentPublication}
            />
          );
        })}
        <div
          css={css`
            position: absolute;
            background-repeat: repeat;
            width: 100%;
            height: 100vh;
            z-index: -1;
            margin-top: 20px;
          `}
        >
          {orderedPublications.map((pub) => (
            <div
              key={pub.filename + "shelf"}
              css={({ breakpoints }) => css`
                margin-top: 180px;

                @media (max-width: ${breakpoints.values.xl}px) {
                  margin-top: 120px;
                }
                width: 100%;
                height: 140px;
                background-image: url("${Shelf}");
                z-index: -1;
              `}
            ></div>
          ))}
        </div>
      </div>
    </>
  );
};
